import React, { useState } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { Typography } from "@mui/material";
import "./contactus.css";

function Contactus() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const [status, setStatus] = useState({
    loading: false,
    success: "",
    error: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    setStatus({
      loading: true,
      success: "",
      error: "",
    });
  
    try {
      const payload = {
        access_key: process.env.REACT_APP_WEB3FORMS_ACCESS_KEY,
        name: formData.name,
        email: formData.email,
        message: formData.message,
        subject: "New Celsius website enquiry",
        from_name: "Celsius Website",
        botcheck: false,
      };
  
      console.log("Submitting payload:", payload);
  
      const response = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(payload),
      });
  
      const result = await response.json();
      console.log("Web3Forms response:", result);
  
      if (response.ok && result.success) {
        setStatus({
          loading: false,
          success: "Thanks — your query has been submitted.",
          error: "",
        });
  
        setFormData({
          name: "",
          email: "",
          message: "",
        });
      } else {
        setStatus({
          loading: false,
          success: "",
          error: result.message || "Something went wrong. Please try again.",
        });
      }
    } catch (error) {
      console.error("Submit error:", error);
      setStatus({
        loading: false,
        success: "",
        error: "Unable to submit right now. Please try again later.",
      });
    }
  };

  return (
    <div>
      <Navbar />

      <main className="contact-page">
        <section className="contact-hero page-shell">
          <div className="contact-hero-copy">
            <Typography className="contact-title">Contact Us</Typography>
            <Typography className="contact-subtitle">
              Reach out for industrial refrigeration systems, gas liquefaction,
              cold storage, process chillers, and custom project enquiries.
            </Typography>
          </div>
        </section>

        <section className="page-shell contact-grid">
          <div className="contact-info-card">
            <Typography className="contact-section-title">
              Get in touch
            </Typography>

            <div className="contact-info-list">
              <div className="contact-info-item">
                <Typography className="contact-label">Phone</Typography>
                <div className="contact-values">
                  <a href="tel:+919650012315" className="contact-link">
                    Arun: +91 96500 12315
                  </a>
                  <a href="tel:+919716064701" className="contact-link">
                    Honey: +91 97160 64701
                  </a>
                  <a href="tel:+919810280278" className="contact-link">
                    Animesh: +91 98102 80278
                  </a>
                </div>
              </div>

              <div className="contact-info-item">
                <Typography className="contact-label">Email</Typography>
                <div className="contact-values">
                  <a href="mailto:info@celsius.in" className="contact-link">
                    info@celsius.in
                  </a>
                </div>
              </div>

              <div className="contact-info-item">
                <Typography className="contact-label">Address</Typography>
                <div className="contact-values">
                  <Typography className="contact-text">
                    E199, EPIP, RIICO Industrial Area, Neemrana, Rajasthan
                    301705
                  </Typography>

                  <div className="contact-map-frame">
                    <iframe
                      title="Celsius location map"
                      loading="lazy"
                      referrerPolicy="no-referrer-when-downgrade"
                      allowFullScreen
                      src={`https://www.google.com/maps/embed/v1/place?key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}&q=${encodeURIComponent("Celsius Neemrana Rajasthan India")}`}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="contact-form-card">
            <Typography className="contact-section-title">
              Send us a query
            </Typography>

            <form className="contact-form" onSubmit={handleSubmit}>
              <div className="contact-form-group">
                <label htmlFor="name" className="contact-form-label">
                  Name
                </label>
                <input
                  id="name"
                  name="name"
                  type="text"
                  className="contact-input"
                  placeholder="Your name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="contact-form-group">
                <label htmlFor="email" className="contact-form-label">
                  Email
                </label>
                <input
                  id="email"
                  name="email"
                  type="email"
                  className="contact-input"
                  placeholder="you@example.com"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="contact-form-group">
                <label htmlFor="message" className="contact-form-label">
                  Message
                </label>
                <textarea
                  id="message"
                  name="message"
                  className="contact-input contact-textarea"
                  placeholder="Tell us about your requirement"
                  value={formData.message}
                  onChange={handleChange}
                  rows={6}
                  required
                />
              </div>

              <button
                type="submit"
                className="contact-submit-button"
                disabled={status.loading}
              >
                {status.loading ? "Submitting..." : "Submit Query"}
              </button>

              {status.success && (
                <Typography className="contact-form-success">
                  {status.success}
                </Typography>
              )}

              {status.error && (
                <Typography className="contact-form-error">
                  {status.error}
                </Typography>
              )}
            </form>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}

export default Contactus;